import axios from 'axios';
import lodash from 'lodash';
import * as type from '../../action-type';
import * as commonActions from '../../common.actions';
import getApiUrl from '../../helpers/api-urls';
import * as utilCommon from '../../helpers/util-common';
import { cookieKeysEnum } from '../common.models';
import { appConfig } from '../../helpers/appConfig';


export const authenticateByAzureADAction = (dispatch: any, callback: any) => {
	const url = getApiUrl('login', 'authenticateByAzureAD');
	dispatch(commonActions.setLoader(true))
	axios.get(url).then((response) => {
		dispatch(commonActions.setLoader(false))
		if (lodash.get(response.data, 'success')) {
			utilCommon.setLoginDataToCacheManager(response, 'LOGIN'); // Add details in LS.
			dispatch({ type: type.AZURE_LOGIN, payload: response });
			// Return true if get accessToken from OSL
			callback(true, lodash.get(response.data, 'message'));
		} else {
			utilCommon.setLoginDataToCacheManager(response, 'DELETE');
			callback(false, lodash.get(response.data, 'message'));
		}

	})
		.catch((err) => {
			const uniqueRequestId = utilCommon.getApiUniqueRequestId(url);
			dispatch(commonActions.setLoader(false));
			dispatch(commonActions.setMessage(true, '1012', uniqueRequestId));
		});
};

export const getAuthKeys = (dispatch: any, callback: any) => {
	const url = getApiUrl('login', 'getAuthkeys');
	const headers: Record<string, string> = {};
	const token = utilCommon.cacheManager.getItem(cookieKeysEnum.accessToken, false);
	if (token) {
		headers.Authorization = `Bearer ${token}`;
	}
	dispatch(commonActions.setLoader(true));
	axios.get(url, { headers }).then((response) => {
		dispatch(commonActions.setLoader(false));
		if (response.data.status) {
			callback(true, lodash.get(response.data, 'message'), response.data.content);
			appConfig.setEncryptionKey(response.data.content.APP_ENCRYPTION_KEY);
			appConfig.setDatadogClientToken(response.data.content.REACT_APP_DATADOG_CLIENT_TOKEN);
		}
	}).catch((err) => {
		const uniqueRequestId = utilCommon.getApiUniqueRequestId(url);
		dispatch(commonActions.setLoader(false));
		dispatch(commonActions.setMessage(true, '1012', uniqueRequestId));
		if (callback) {
			callback(false, '1012', null);
		}
	});
};

// Auth by Cookies token
export const authByCookiesTokenAction = (dispatch: any, inputDTO: any, callback: any) => {
	const url = getApiUrl('login', 'authCookiesToken');
	dispatch(commonActions.setLoader(true))
	axios.post(url, { source: inputDTO.appId }).then((response) => {
		dispatch(commonActions.setLoader(false));
		if (lodash.get(response.data, 'success')) {
			utilCommon.setLoginDataToCacheManager(response, 'LOGIN'); // Add details in LS.
			// Return true if get accessToken from OSL
			callback(true, lodash.get(response.data, 'message'));
		} else {
			utilCommon.setLoginDataToCacheManager(response, 'DELETE');
			callback(false, lodash.get(response.data, 'message'));
		}
	})
		.catch((err) => {
			dispatch(commonActions.setLoader(false));
		});
};
export const checkSessionInfo = (dispatch: any, callback: any) => {
	const url = getApiUrl('login', 'checkSessionInfo');
	dispatch(commonActions.setLoader(true))
	axios.get(url).then((response) => {
		dispatch(commonActions.setLoader(false))
		if (lodash.get(response.data, 'success')) {
			//utilCommon.setLoginDataToCacheManager(response, 'LOGIN'); // Add details in LS.
			// Return true if get accessToken from OSL
			callback(response.data, lodash.get(response.data, 'message'));
		} else {
			//utilCommon.setLoginDataToCacheManager(response, 'DELETE');
			callback(false, lodash.get(response.data, 'message'));
		}
	})
		.catch((err) => {
			dispatch(commonActions.setLoader(false));
		});
}

export default {
	authenticateByAzureADAction,
	getAuthKeys,
	authByCookiesTokenAction,
	checkSessionInfo
};
